import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { googleAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = match[1];
    
    (async () => {
      try {
        const userData = await googleAuth(sessionId);
        const email = userData?.email || "";
        // Check subscription to decide redirect
        try {
          const subRes = await axios.get(`${API}/subscription/status?email=${encodeURIComponent(email)}`);
          const isSubscribed = subRes.data?.status === "active" || email === "torregrossa.joseph@gmail.com";
          navigate(isSubscribed ? "/dashboard" : "/subscription", { replace: true });
        } catch {
          navigate("/subscription", { replace: true });
        }
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <Loader2 className="animate-spin text-[#00E676] mx-auto mb-4" size={48} />
        <p className="text-white font-bold uppercase tracking-wider">Connexion Google en cours...</p>
      </div>
    </div>
  );
}
